import { render, staticRenderFns } from "./WebPanel.vue?vue&type=template&id=63698502&scoped=true&"
import script from "./WebPanel.vue?vue&type=script&lang=ts&"
export * from "./WebPanel.vue?vue&type=script&lang=ts&"
import style0 from "./WebPanel.vue?vue&type=style&index=0&lang=postcss&"
import style1 from "./WebPanel.vue?vue&type=style&index=1&id=63698502&lang=postcss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../vue-loader-virtual-c5444c0a66/0/cache/vue-loader-npm-15.9.1-90a0e5830b-a9a3ffbe3c.zip/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63698502",
  null
  
)

export default component.exports